import { isSunnyDay, type PlaceForecast, type WeatherKind } from "./weather";

export function areaDaySummary(places: PlaceForecast[], date: string) {
  const forecasts = places.flatMap(place => { const day = place.days.find(item => item.date === date); return day ? [day] : []; });
  const sunny = forecasts.filter(isSunnyDay).length;
  const total = forecasts.length;
  const percentage = total ? Math.round(sunny / total * 100) : 0;
  const kind: WeatherKind = total && sunny / total >= .5 ? "clear" : sunny > 0 ? "partly-cloudy" : "cloudy";
  return { sunny, total, percentage, kind };
}
